/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

// Function to remove accents/diacritics from characters (similar to WordPress remove_accents)
function removeAccents(str) {
	const accentMap = {
		À: "A",
		Á: "A",
		Â: "A",
		Ã: "A",
		Ä: "A",
		Å: "A",
		à: "a",
		á: "a",
		â: "a",
		ã: "a",
		ä: "a",
		å: "a",
		Ò: "O",
		Ó: "O",
		Ô: "O",
		Õ: "O",
		Ö: "O",
		Ø: "O",
		ò: "o",
		ó: "o",
		ô: "o",
		õ: "o",
		ö: "o",
		ø: "o",
		È: "E",
		É: "E",
		Ê: "E",
		Ë: "E",
		è: "e",
		é: "e",
		ê: "e",
		ë: "e",
		Ç: "C",
		ç: "c",
		Ì: "I",
		Í: "I",
		Î: "I",
		Ï: "I",
		ì: "i",
		í: "i",
		î: "i",
		ï: "i",
		Ù: "U",
		Ú: "U",
		Û: "U",
		Ü: "U",
		ù: "u",
		ú: "u",
		û: "u",
		ü: "u",
		ÿ: "y",
		Ÿ: "Y",
		Ñ: "N",
		ñ: "n",
		ß: "ss",
		Æ: "AE",
		æ: "ae",
		Œ: "OE",
		œ: "oe",
	};

	return str.replace(/[^\u0000-\u007E]/g, (char) => accentMap[char] || char);
}

// Select all headings on the page, including those inside group blocks
const headings = document.querySelectorAll("h1, h2, h3");

headings.forEach((heading) => {
	// Skip headings that are inside the TOC itself
	if (heading.closest(".toc")) {
		return;
	}

	// Set IDs for headings that don't have one
	if (!heading.id) {
		const headingText = removeAccents(heading.textContent)
			.toLowerCase()
			.replace(/[^a-z0-9\s-]/g, "")
			.trim()
			.replace(/\s+/g, "-");

		heading.id = "h-" + headingText;
	}
});

document.querySelectorAll('.toc a[href^="#"]').forEach((link) => {
	link.addEventListener("click", (e) => {
		e.preventDefault();
		const targetId = link.getAttribute("href").slice(1);
		const targetElement = document.getElementById(targetId);

		if (targetElement) {
			const offset = 200;
			const elementPosition = targetElement.getBoundingClientRect().top;
			const offsetPosition = elementPosition + window.pageYOffset - offset;

			const prefersReducedMotion = window.matchMedia(
				"(prefers-reduced-motion: reduce)",
			).matches;

			window.scrollTo({
				top: offsetPosition,
				behavior: prefersReducedMotion ? "auto" : "smooth",
			});
		}
	});
});
